import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  colors,
  type PrimitivePropsWithRef,
  Text,
  VStack,
} from '@rtkwlf/fenrir-react';
import { faExclamationTriangle } from '@rtkwlf/pro-regular-svg-icons/faExclamationTriangle';
import { useTranslation } from 'react-i18next';

type ErrorProps = PrimitivePropsWithRef<'div'> & {
  title?: string | React.ReactElement;
  message?: string | React.ReactElement;
};

/** @deprecated Please use packages/fenrir/feedback/errors/error */
export const Error = ({ title, message, ...css }: ErrorProps) => {
  const { t } = useTranslation('error', { keyPrefix: 'generalErrorMessage' });
  const errorTitle = title ?? t('title');
  const errorMessage = message ?? t('content');

  return (
    <VStack {...css} xAlign="center" padding="large">
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        color={`rgb(${colors.accent.grey.default})`}
        style={{
          height: '50px',
          width: '55px',
        }}
      />
      <Text textAlign="center" style={{ whiteSpace: 'pre-line' }}>
        {errorTitle}
      </Text>
      <Text textAlign="center" style={{ whiteSpace: 'pre-line' }}>
        {errorMessage}
      </Text>
    </VStack>
  );
};
